import { PREFERENCE_MAXIMUM_LIMIT } from "@repo/shared";

export type PreferenceMaximumsError = "wholeNumber" | "perAboveTotal";

export type PreferenceMaximumsReading =
  | { error: null; maxPerPreference: number; maxTotalPreferences: number }
  | { error: PreferenceMaximumsError };

/** A whole percentage from 0 to the limit, or null when the text is anything else. */
function parseMaximum(text: string): number | null {
  if (!/^\d+$/.test(text.trim())) return null;
  const value = Number(text);
  return value <= PREFERENCE_MAXIMUM_LIMIT ? value : null;
}

/**
 * The two preference maximums as typed into their fields, or why they cannot
 * be saved. The checks mirror the service's.
 */
export function readPreferenceMaximums(
  perPreferenceText: string,
  totalText: string,
): PreferenceMaximumsReading {
  const maxPerPreference = parseMaximum(perPreferenceText);
  const maxTotalPreferences = parseMaximum(totalText);
  if (maxPerPreference == null || maxTotalPreferences == null) return { error: "wholeNumber" };
  if (maxPerPreference > maxTotalPreferences) return { error: "perAboveTotal" };
  return { error: null, maxPerPreference, maxTotalPreferences };
}
